function LoaderSpin({ size = 5.5, className }) {
  const sizeValue = size * 4 + 'px'

  return (
    <div
      className={`animate-spin rounded-full border-2 border-default border-t-accent-1 ${className}`}
      style={{ width: sizeValue, height: sizeValue }}
    ></div>
  )
}

export default LoaderSpin
